/**
 *
 *
 *
 *
 * THIS DOCUMENT IS THE VUEX STORE FILE
 * IT IS THE STATE MACHINE PART OF THE APP
 *
 * this needs a lot of work becuase some of the app components
 * are using state and some are not due to time constraints
 * because I don't have a server this might not be necessary
 * but as the app gets more complex this makes more and more sense to build out better
 *
 *
 *
 *
 *
 */

import Vue from "vue";
import Vuex from "vuex";
import * as firebase from "firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appMessage: null,
    user: null,
    role: null,
    matters: [],
    firm: null,
    error: null,
    loading: false,
    initialDocs: [],
    viewingParty: null,
    viewingPlaintiff: null,
    viewingDefendant: null,
    viewingResponse: null,
    selectedParties: [],
    propertySlug: null
    // clientFormList: null
  },
  mutations: {
    setProperty(state, payload) {
      state.propertySlug = payload;
    },
    setAppMessage(state, payload) {
      state.appMessage = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    //CONTENTS
    setContents(state, payload) {
      state.contentsList = payload;
    },
    //USER
    setUser(state, payload) {
      state.user = payload;
    },
    //ROLE
    setRole(state, payload) {
      state.role = payload;
    },
    //FIRM
    setFirm(state, payload) {
      state.firm = payload;
    },
    //MATTER
    setMatter(state, payload) {
      const foundMatter = state.matters.find(
        matter => matter.matterSlug === payload.matterSlug
      );
      if (foundMatter !== null && foundMatter !== undefined) {
        return;
      } else {
        state.matters.push(payload);
      }
    },
    modifyMatter(state, payload) {
      console.log("modifying matter:", payload);
      const existingMatter = state.matters.find(
        matter => matter.matterSlug === payload.matterSlug
      );
      const index = state.matters.indexOf(existingMatter);
      const updatedMatter = Object.assign(existingMatter, payload);
      state.matters.splice(index, 1, updatedMatter);
    },
    removeMatter(state, payload) {
      const existingMatter = state.matters.find(
        matter => matter.matterSlug === payload.matterSlug
      );
      const index = state.matters.indexOf(existingMatter);
      state.matters.splice(index, 1);
    },
    clearMatters(state) {
      state.matters = [];
    },

    //PLAINTIFFS
    setPlaintiff(state, payload) {
      state.viewingPlaintiff = payload;
    },
    setResponse(state, payload) {
      state.viewingResponse = payload;
    },
    clearPlaintiff(state) {
      state.viewingPlaintiff = null;
    },
    setDefendant(state, payload) {
      state.viewingDefendant = payload;
    },
    clearDefendant(state) {
      state.viewingDefendant = null;
    },
    removePlaintiff(state, payload) {
      const existingPlaintiff = state.plaintiffs.find(
        plaintiff => plaintiff.name === payload.name
      );
      const index = state.plaintiffs.indexOf(existingPlaintiff);
      state.plaintiffs.splice(index, 1);
    },
    modifyPlaintiff(state, payload) {
      const existingPlaintiff = state.plaintiffs.find(
        plaintiff => plaintiff.name === payload.name
      );
      const index = state.plaintiffs.indexOf(existingPlaintiff);
      const updatedPlaintiff = Object.assign(existingPlaintiff, payload);
      state.plaintiffs.splice(index, 1, updatedPlaintiff);
    },
    clearPlaintiffs(state) {
      state.plaintiffs = [];
    },

    //INITIAL DOCS
    setInitialDocs(state, payload) {
      // console.log("setting initial docs", payload);
      state.initialDocs = payload;
      // console.log("this is state now", state);
    },
    clearInitialDocs(state) {
      state.initialDocs = [];
    },
    // logInitialDocs(state) {
    //   console.log("logging init docs from mutations", state.initialDocs);
    // },
    removeInitialDoc(state, payload) {
      const existingDoc = state.intitialDocs.find(
        doc => doc.name === payload.name
      );
      const index = state.initialDocs.indexOf(existingDoc);
      state.initialDocs.splice(index, 1);
    },
    setParty(state, payload) {
      state.viewingParty = payload;
    },
    clearParty(state) {
      state.viewingParty = null;
    }
    // setClientFormList(state, payload) {
    //   state.clientFormList = payload;
    // }
  },
  actions: {
    signUserIn({ commit }, payload) {
      let newUser = null;
      //SIGN USER IN
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(resp => {
          //GET THE USER FROM DATABASE
          resp.user
            .getIdTokenResult()
            .then(idTokenResult => {
              //ADMIN
              console.log(idTokenResult.claims);
              if (idTokenResult.claims.admin) {
                let role = "admin";
                commit("setRole", role);
                firebase
                  .firestore()
                  .collection("users")
                  .doc(resp.user.email)
                  .get()
                  .then(user => {
                    newUser = user.data();
                    //SET USER
                    commit("setUser", newUser);
                    // return newUser;
                  });
              }
              if (idTokenResult.claims.client) {
                //CLIENT
                let role = "client";
                commit("setRole", role);
                firebase
                  .firestore()
                  // .collection("firms")
                  // .doc(payload.firm)
                  .collection("matters")
                  .doc(payload.matter)
                  .collection("clients")
                  .doc(payload.client)
                  .get()
                  .then(user => {
                    newUser = user.data();
                    //SET USER
                    commit("setUser", newUser);
                    console.log("newUser", newUser);
                    if (!newUser.fullName) {
                      firebase
                        .firestore()
                        // .collection("firms")
                        // .doc(payload.firm)
                        .collection("matters")
                        .doc(payload.matter)
                        .collection("clients")
                        .doc(payload.client)
                        .update({
                          firstName: payload.firstName,
                          lastName: payload.lastName,
                          phone: payload.phone,
                          fullName: payload.fullName,
                          //experimental
                          partyType: payload.partyType
                        })
                        .then(() => {
                          //get user again
                          console.log(
                            "added name and patrytype to the database"
                          );
                          firebase
                            .firestore()
                            // .collection("firms")
                            // .doc(payload.firm)
                            .collection("matters")
                            .doc(payload.matter)
                            .collection("clients")
                            .doc(payload.client)
                            .get()
                            .then(user => {
                              newUser = user.data();
                              //SET USER
                              commit("setUser", newUser);
                              console.log("user set", newUser);
                            })
                            .catch(e => console.log(e));
                        })
                        .catch(e => console.log(e));
                    }
                    // return newUser;
                    //get the formList and set the formList
                    //dont need this right now
                    // firebase
                    //   .firestore()
                    //   .collection("firms")
                    //   .doc(payload.firm)
                    //   .collection("matters")
                    //   .doc(payload.matter)
                    //   .collection("clients")
                    //   .doc(payload.client)
                    //   .collection("formList")
                    //   .get()
                    //   .then(snapShot => {
                    //     let formList = [];
                    //     snapShot.forEach(form => {
                    //       formList.push(form);
                    //     });
                    //     commit("setClientFormList", formList);
                    //   }).catch(e => {
                    //     console.log(e);
                    //     commit("setAppMessage", e.message);
                    //   });
                  })
                  .catch(e => {
                    console.log(e);
                    commit("setAppMessage", e.message);
                  });
              }
            })
            .catch(e => {
              console.log(e);
              commit("setAppMessage", e.message);
            });
        })
        .catch(e => {
          console.log(e);
          commit("setAppMessage", e.message);
        });
    },
    setRole({ commit }, payload) {
      commit("setRole", payload);
    },
    clearRole({ commit }, payload) {
      commit("setRole", payload);
    },
    setAnonymousUser({ commit }) {
      let user = {
        name: "Anonymous User"
      };
      commit("setUser", user);
    },
    setPropertySlug({ commit }, payload) {
      commit("setProperty", payload);
    },
    autoLoginAdmin({ commit }, payload) {
      console.log(payload);
      firebase
        .firestore()
        .collection("users")
        .doc(payload)
        .get()
        .then(user => {
          let newUser = user.data();
          //SET USER
          commit("setUser", newUser);
          console.log(newUser);
          return newUser;
        })
        .then(newUser => {
          let matterRef = firebase
            .firestore()
            // .collection("firms")
            // .doc(newUser.firmSlug)
            .collection("matters")
            .where("sharedWith", "array-contains", newUser.email);

          matterRef.onSnapshot(res => {
            const changes = res.docChanges();
            // console.log(changes);
            changes.forEach(change => {
              if (change.type === "added") {
                const matter = change.doc.data();
                //if matter.sharedWith includes payload.user
                // if (matter.sharedWith.includes(payload.user)) {
                // console.log("included", payload.user);
                let plaintiffCount = 0;
                let formCount = 0;
                if (matter.plaintiffs.length > 0) {
                  matter.plaintiffs.forEach(plaintiff => {
                    plaintiffCount++;
                    if (plaintiff.formList && plaintiff.formList.length > 0) {
                      formCount++;
                    }
                  });
                }
                let value = "";
                value = `${formCount.toString()}/${plaintiffCount.toString()}`;
                // console.log("formCount", formCount);
                matter.formCount = value;
                commit("setMatter", matter);
                // } else {
                //   console.log("not included", payload.user);
                // }
                // commit("setMatter", matter);
              } else if (change.type === "modified") {
                const modifiedMatter = change.doc.data();
                //if matter.sharedWith includes payload.user
                // if (modifiedMatter.sharedWith.includes(payload.user)) {
                let plaintiffCount = 0;
                let formCount = 0;
                if (modifiedMatter.plaintiffs.length > 0) {
                  modifiedMatter.plaintiffs.forEach(plaintiff => {
                    plaintiffCount++;
                    if (plaintiff.formList && plaintiff.formList.length > 0) {
                      formCount++;
                    }
                  });
                }
                let value = "";
                value = `${formCount.toString()}/${plaintiffCount.toString()}`;
                // console.log("formCount", formCount);
                modifiedMatter.formCount = value;
                commit("modifyMatter", modifiedMatter);
                // }
                // commit("modifyMatter", modifiedMatter);
              } else if (change.type === "removed") {
                const removedMatter = change.doc.data();
                commit("removeMatter", removedMatter);
              }
            });
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    //if the user is at the ContentsList component
    //they are assumed to be a fire client and have a different login procedure
    autoLoginFireClient({ commit }, payload) {
      console.log("payload", payload);
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(payload.matter)
        .get()
        .then(matter => {
          let data = matter.data();
          // let contentsList = data.contentsList;
          //SET USER
          // commit("setContents", contentsList);
          // console.log("contentsList", contentsList);
          let user = {
            email: payload.user.email,
            phone: payload.user.phoneNumber,
            // propertySlug: data.propertySlug,
            matterID: data.matterID
          };
          commit("setUser", user);
        })
        .catch(err => {
          console.log(err);
        });
    },
    autoLoginClient({ commit }, payload) {
      firebase
        .firestore()
        // .collection("firms")
        // .doc(payload.firm)
        .collection("matters")
        .doc(payload.matter)
        .collection("clients")
        .doc(payload.client)
        .get()
        .then(user => {
          let newUser = user.data();
          //SET USER
          commit("setUser", newUser);
          console.log("newUser", newUser);
          // return newUser;
          //DONT NEED RIGHT NOW
          // firebase
          //   .firestore()
          //   .collection("firms")
          //   .doc(payload.firm)
          //   .collection("matters")
          //   .doc(payload.matter)
          //   .collection("clients")
          //   .doc(payload.client)
          //   .collection("formList")
          //   .get()
          //   .then(snapShot => {
          //     let formList = [];
          //     snapShot.forEach(form => {
          //       formList.push(form);
          //     });
          //     commit("setClientFormList", formList);
          //   }).catch(e => {
          //     console.log(e);
          //     commit("setAppMessage", e.message);
          //   });
        })
        .catch(err => {
          console.log(err);
        });
    },

    logout({ commit }) {
      firebase.auth().signOut();
      commit("setUser", null);
      commit("setFirm", null);
      commit("setRole", null);
      commit("clearMatters");
    },
    addFirmActivity({ commit }, payload) {
      commit("setLoading", true);
      firebase
        .firestore()
        .collection("firms")
        .doc(payload.firmSlug)
        .update({
          activities: firebase.firestore.FieldValue.arrayUnion(payload.activity)
        })
        .then(() => {
          console.log("activity added to firm", payload.activity);
          commit("setLoading", false);
        })
        .catch(e => {
          console.error(e);
        });
    },
    addMatterActivity({ commit }, payload) {
      commit("setLoading", true);
      firebase
        .firestore()
        // .collection("firms")
        // .doc(payload.firmSlug)
        .collection("matters")
        .doc(payload.matterSlug)
        .update({
          activities: firebase.firestore.FieldValue.arrayUnion(payload.activity)
        })
        .then(() => {
          console.log("activity added to firm", payload.activity);
          commit("setLoading", false);
        })
        .catch(e => {
          console.error(e);
        });
    },
    getFirm({ commit }, payload) {
      firebase
        .firestore()
        .collection("firms")
        .doc(payload)
        .onSnapshot(res => {
          let data = res.data();
          console.log("firm data", data);

          commit("setFirm", data);
        });
    },
    getMatters({ commit }, payload) {
      console.log("fire getMatters");

      let matterRef = firebase
        .firestore()
        .collection("matters")
        .where("sharedWith", "array-contains", payload.user);

      matterRef.onSnapshot(res => {
        const changes = res.docChanges();
        // console.log(changes);
        changes.forEach(change => {
          if (change.type === "added") {
            let matter = change.doc.data();
            let plaintiffCount = 0;
            let formCount = 0;
            if (matter.plaintiffs.length > 0) {
              matter.plaintiffs.forEach(plaintiff => {
                plaintiffCount++;
                if (plaintiff.formList && plaintiff.formList.length > 0) {
                  formCount++;
                }
              });
            }
            let value = "";
            value = `${formCount.toString()}/${plaintiffCount.toString()}`;
            // console.log("formCount", formCount);
            matter.formCount = value;
            //if matter.sharedWith includes payload.user
            // if (matter.sharedWith.includes(payload.user)) {
            // console.log("included", payload.user);
            commit("setMatter", matter);
            // } else {
            //   console.log("not included", payload.user);
            // }
            // commit("setMatter", matter);
          } else if (change.type === "modified") {
            const modifiedMatter = change.doc.data();
            //if matter.sharedWith includes payload.user
            // if (modifiedMatter.sharedWith.includes(payload.user)) {
            let plaintiffCount = 0;
            let formCount = 0;
            if (modifiedMatter.plaintiffs.length > 0) {
              modifiedMatter.plaintiffs.forEach(plaintiff => {
                plaintiffCount++;
                if (plaintiff.formList && plaintiff.formList.length > 0) {
                  formCount++;
                }
              });
            }
            let value = 0;
            value = `${formCount}/${plaintiffCount}`;

            modifiedMatter.formCount = value;
            commit("modifyMatter", modifiedMatter);
            // }
            // commit("modifyMatter", modifiedMatter);
          } else if (change.type === "removed") {
            const removedMatter = change.doc.data();
            commit("removeMatter", removedMatter);
          }
        });
      });

      // citiesRef.where("regions", "array-contains", "west_coast")
    },
    createMatter({ commit }, payload) {
      console.log(payload);
      commit("setLoading", true);
      commit("clearInitialDocs");
      // commit("logInitialDocs");
      firebase
        .firestore()
        .collection("firms")
        .doc(payload.firmSlug)
        .collection("matters")
        .doc(payload.data.matterSlug)
        .set(payload.data)

        .then(() => {
          //  add something to firm activities
          firebase
            .firestore()
            .collection("matters")
            .doc(payload.data.matterSlug)
            .set(payload.data);
        });
      commit("setLoading", false);
    },
    /**
     * this needs a lot of work 
     * it should be a onCall cloud function
     * that recursively deletes the collection 
     * and its subcollections while making sure the 
     * auth token of the caller is "admin" 
     * 
    exports.recursiveDelete = functions
      .runWith({
        timeoutSeconds: 540,
        memory: '2GB'
      })
      .https.onCall(async (data, context) => {
        // Only allow admin users to execute this function.

        if (!(context.auth && context.auth.token && context.auth.token.admin)) {
          throw new functions.https.HttpsError(
            'permission-denied',
            'Must be an administrative user to initiate delete.'
          );
        }

        const path = data.path;
        console.log(
          `User ${context.auth.uid} has requested to delete path ${path}`
        );

        // Run a recursive delete on the given document or collection path.
        // The 'token' must be set in the functions config, and can be generated
        // at the command line by running 'firebase login:ci'.
        await firebase_tools.firestore
          .delete(path, {
            project: process.env.GCLOUD_PROJECT,
            recursive: true,
            yes: true,
            token: functions.config().fb.token
          });
          //then delete the storage files for the matter
          
        return {
          path: path 
        };
      });
      
      * Call the 'recursiveDelete' callable function with a path and a storage path to initiate
      * a server-side delete.
 
      function deleteAtPath(path) {
        var deleteFn = firebase.functions().httpsCallable('recursiveDelete');
        deleteFn({ path: path, storagePath: storagePath })
            .then(function(result) {
                logMessage('Delete success: ' + JSON.stringify(result));
            })
            .catch(function(err) {
                logMessage('Delete failed, see console,');
                console.warn(err);
            });
      }

     */
    deleteMatter({ commit }, payload) {
      commit("setLoading", true);
      if (payload.matter.creatorID == payload.user.email) {
        firebase
          .firestore()
          .collection("firms")
          .doc(payload.user.firmSlug)
          .collection("matters")
          .doc(payload.matter.matterSlug)
          .delete()
          .then(() => {
            //  add something to firm activities
            firebase
              .firestore()
              .collection("matters")
              .doc(payload.matter.matterSlug)
              .delete();
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        alert("you are not permitted to delete this matter");
      }
      commit("setLoading", false);
    },
    editMatter({ commit }, payload) {
      commit("setLoading", true);
      //delete the old matter
      firebase
        .firestore()
        .collection("firms")
        .doc(payload.firmSlug)
        .collection("matters")
        .doc(payload.changes.matterSlug)
        .update(payload.changes)
        .then(() => {
          //  add something to firm activities
          //see addPlaintiff() below
          firebase
            .firestore()
            .collection("matters")
            .doc(payload.changes.matterSlug)
            .update(payload.changes)
            .then(() => {
              commit("setLoading", false);
            })
            .catch(err => {
              console.error(err);
            });
        })
        .catch(err => {
          console.error(err);
        });
    },
    addInitialDocs({ commit }, payload) {
      commit("setLoading", true);
      const initialDocUrls = [];

      payload.initialDocs.forEach(doc => {
        const docName = doc.name;
        const ref = firebase
          .storage()
          .ref(
            `firms/${payload.firmSlug}/matters/${payload.matterSlug}/initial_docs/${docName}`
          );
        ref
          .put(doc)
          .then(() => {
            console.log("initialdoc successfully stored");
            ref
              .getDownloadURL()
              .then(url => {
                initialDocUrls.push({
                  url,
                  name: doc.name
                });
              })
              .then(() => {
                initialDocUrls.forEach(doc => {
                  firebase
                    .firestore()
                    .collection("firms")
                    .doc(payload.firmSlug)
                    .collection("matters")
                    .doc(payload.matterSlug)
                    //experimental
                    .update({
                      "caseDocs.initialDocs": firebase.firestore.FieldValue.arrayUnion(
                        doc
                      )
                    })
                    .then(() => {
                      firebase
                        .firestore()
                        .collection("matters")
                        .doc(payload.matterSlug)
                        .update({
                          "caseDocs.initialDocs": firebase.firestore.FieldValue.arrayUnion(
                            doc
                          )
                        })
                        .catch(e => console.log(e));
                    })
                    .catch(e => console.log(e));
                });
              })
              .catch(e => console.log(e));
          })
          .catch(e => console.log(e));
      });
      commit("setLoading", false);
    },
    addPlaintiff({ commit }, payload) {
      // get in there and save that plaintiff
      const plaintiff = payload.plaintiff;
      const activity = payload.activity;
      commit("setLoading", true);
      console.log(payload);
      firebase
        .firestore()
        .collection("firms")
        .doc(payload.firmSlug)
        .collection("matters")
        .doc(payload.matterSlug)
        .update({
          plaintiffs: firebase.firestore.FieldValue.arrayUnion(plaintiff),
          activities: firebase.firestore.FieldValue.arrayUnion(activity)
        })
        .then(() => {
          console.log("successfully added plaintiff");
          firebase
            .firestore()
            .collection("firms")
            .doc(payload.firmSlug)
            .update({
              activities: firebase.firestore.FieldValue.arrayUnion(activity)
            })
            .then(() => {
              console.log("successfully added firm activity");
              firebase
                .firestore()
                .collection("matters")
                .doc(payload.matterSlug)
                .update({
                  plaintiffs: firebase.firestore.FieldValue.arrayUnion(
                    plaintiff
                  ),
                  activities: firebase.firestore.FieldValue.arrayUnion(activity)
                })
                .catch(e => console.log(e));
            })
            .catch(e => console.log(e));
        })
        .catch(e => console.log(e));

      commit("setLoading", false);
    },
    // addFirmAttorneys({commit}, payload){
    //   commit("setFirmAttorneys");
    // },
    // editPlaintiff({ commit }, payload) {

    // },

    addDefendant({ commit }, payload) {
      // get in there and save that plaintiff
      const defendant = payload.defendant;
      const activity = payload.activity;
      commit("setLoading", true);
      console.log(payload);
      // firebase
      //   .firestore()
      //   .collection("firms")
      //   .doc(payload.firmSlug)
      //   .collection("matters")
      //   .doc(payload.matterSlug)
      //   .update({
      //     defendants: firebase.firestore.FieldValue.arrayUnion(defendant)
      //   })
      //   .then(() => {
      //     console.log("successfully added defendant");
      //     firebase
      //       .firestore()
      //       .collection("firms")
      //       .doc(payload.firmSlug)
      //       .update({
      //         activities: firebase.firestore.FieldValue.arrayUnion(activity)
      //       })
      // .then(() => {
      // console.log("successfully added firm activity");
      firebase
        .firestore()
        .collection("matters")
        .doc(payload.matterSlug)
        .update({
          defendants: firebase.firestore.FieldValue.arrayUnion(defendant),
          activities: firebase.firestore.FieldValue.arrayUnion(activity)
        })
        .catch(e => console.log(e));
      //     })
      //     .catch(e => console.log(e));
      // })
      // .catch(e => console.log(e));
      // .set({ plaintiffs: [{ plaintiff }] }, { merge: true })

      commit("setLoading", false);
    },
    viewParty({ commit }, payload) {
      commit("setLoading", true);
      commit("setParty", payload);
      commit("setLoading", false);
    },
    clearParty({ commit }) {
      commit("clearParty");
    },
    viewPlaintiff({ commit }, payload) {
      commit("setLoading", true);
      commit("clearPlaintiff");
      commit("setPlaintiff", payload);
      commit("setLoading", false);
    },
    clearPlaintiff({ commit }) {
      commit("clearPlaintiff");
    },
    viewDefendant({ commit }, payload) {
      commit("setLoading", true);
      commit("setDefendant", payload);
      commit("setLoading", false);
    },
    clearDefendant({ commit }) {
      commit("clearDefendant");
    },
    viewResponse({ commit }, payload) {
      commit("setLoading", true);
      commit("setResponse", payload);
      commit("setLoading", false);
    },
    setAppMessage({ commit }, payload) {
      commit("setAppMessage", payload);
    },
    signUserUp({ commit }, payload) {
      commit("setLoading", true);
      commit("clearError");
      //experimental
      // create a reference to a firm
      const firmRef = firebase
        .firestore()
        .collection("firms")
        .doc(payload.firm.firmSlug);
      // .doc(firmSlug);
      const userRef = firebase
        .firestore()
        .collection("users")
        .doc(payload.email);
      //check if the firm exists
      firmRef.get().then(doc => {
        //if firm exists
        if (doc.exists) {
          //dont create a firm collection
          //skip to check if user exists in database
          console.log("firm exists: ", doc);
          // let userRef = firebase.firestore().collection('users').doc(payload.email)
          let firm = doc.data();
          commit("setFirm", firm);
          userRef
            .get()
            .then(doc => {
              //see if this user exists
              if (doc.exists) {
                console.log("user exists: ", doc);
                //return error that user exists
                let error = "this user already exists";
                commit("setError", error);
                commit("setLoading", false);
                return;
              } else {
                //if user doesn't exist in the database
                console.log("this is a new user");
                //create the user auth
                firebase
                  .auth()
                  .createUserWithEmailAndPassword(
                    payload.email,
                    payload.password
                  )
                  .then(resp => {
                    console.log("user created in auth with ID", resp.user.uid);
                    //fire cloud function to set user claim to admin
                    const addAdminRole = firebase
                      .functions()
                      .httpsCallable("addAdminRole");
                    addAdminRole({
                      email: payload.email
                    });

                    const newUser = {
                      ...payload.user,
                      authID: resp.user.uid
                    };
                    //set the new user in database
                    userRef
                      .set(newUser)
                      .then(() => {
                        console.log("new User created in database");
                        //UPDATE USER LIST IN FIRM COLLECTION
                        firmRef
                          .update({
                            userlist: firebase.firestore.FieldValue.arrayUnion(
                              newUser.email
                            )
                          })
                          .then(() => {
                            //SET THE USER
                            // let role = "admin";
                            console.log("setting user in store");
                            commit("setUser", newUser);
                            // commit("setRole", role);

                            let matterRef = firebase
                              .firestore()
                              .collection("matters")
                              .where(
                                "sharedWith",
                                "array-contains",
                                newUser.email
                              );
                            //GRAB MATTERS
                            matterRef
                              .get()
                              .then(matters => {
                                let matterList = [];
                                matters.forEach(matter => {
                                  matterList.push(matter);
                                });
                                //SET THE MATTERS
                                commit("setMatters", matterList);
                              })
                              .then(() => {
                                ///////////////EXPERIMENTAL///////////////////////////////
                                console.log("signing out and signing back in");
                                firebase.auth().signOut();
                                firebase
                                  .auth()
                                  .signInWithEmailAndPassword(
                                    payload.email,
                                    payload.password
                                  )
                                  .then(resp => {
                                    //GET THE USER FROM DATABASE
                                    resp.user
                                      .getIdTokenResult()
                                      .then(idTokenResult => {
                                        // let role = idTokenResult.claims.admin;
                                        if (idTokenResult.claims.admin) {
                                          let role = "admin";
                                          commit("setRole", role);
                                          firebase
                                            .firestore()
                                            .collection("users")
                                            .doc(resp.user.email)
                                            .get()
                                            .then(user => {
                                              user = user.data();
                                              //SET USER
                                              commit("setUser", user);
                                              // return newUser;
                                            })
                                            .catch(e => {
                                              console.log(e);
                                            });
                                        }
                                        if (idTokenResult.claims.client) {
                                          let role = "client";
                                          commit("setRole", role);
                                          firebase
                                            .firestore()
                                            // .collection("firms")
                                            // .doc(payload.firm)
                                            .collection("matters")
                                            .doc(payload.matter)
                                            .collection("clients")
                                            .doc(payload.client)
                                            .get()
                                            .then(user => {
                                              user = user.data();
                                              //SET USER
                                              commit("setUser", user);
                                              // return newUser;
                                            })
                                            .catch(e => {
                                              console.log(e);
                                              commit(
                                                "setAppMessage",
                                                e.message
                                              );
                                            });
                                        }
                                      })
                                      .catch(e => {
                                        console.log(e);
                                        commit("setAppMessage", e.message);
                                      });
                                  })
                                  .catch(e => {
                                    console.log(e);
                                    commit("setAppMessage", e.message);
                                  });
                              })

                              .catch(err => {
                                commit("setError", err);
                                commit("setAppMessage", err.message);
                              });
                          })
                          .catch(err => {
                            commit("setError", err);
                            commit("setAppMessage", err.message);
                          });
                        commit("setLoading", false);
                        console.log("new User email added to firm in database");
                      })
                      .catch(err => {
                        commit("setError", err);
                        commit("setLoading", false);
                        commit("setAppMessage", err.message);
                      });
                  })
                  .catch(err => {
                    commit("setError", err);
                    commit("setLoading", false);
                    commit("setAppMessage", err.message);
                  });
              }
            })
            .catch(err => {
              commit("setError", err);
              commit("setLoading", false);
              commit("setAppMessage", err.message);
            });
        } else {
          //if firm doesnt exist
          //create a firm
          let firm = payload.firm;
          firmRef
            .set(firm)
            .then(resp => {
              console.log("firm created: ", resp);
              //SET THE FIRM
              commit("setFirm", firm);
            })
            .then(() => {
              // see if user ref exists in database
              userRef
                .get()
                .then(doc => {
                  //see if this user exists
                  if (doc.exists) {
                    console.log("user exists: ", doc);
                    //return error that user exists
                    let error = "this user already exists";
                    commit("setError", error);
                    commit("setLoading", false);
                    return;
                  } else {
                    //if user doesn't exist in the database
                    console.log("this is a new user");
                    //create the user auth
                    firebase
                      .auth()
                      .createUserWithEmailAndPassword(
                        payload.email,
                        payload.password
                      )
                      //add admin role
                      .then(resp => {
                        console.log(
                          "user created in auth with ID",
                          resp.user.uid
                        );
                        const addAdminRole = firebase
                          .functions()
                          .httpsCallable("addAdminRole");
                        addAdminRole({
                          email: payload.email
                        });
                        const newUser = {
                          ...payload.user,
                          authID: resp.user.uid
                        };
                        //set the new user in database
                        userRef
                          .set(newUser)
                          .then(() => {
                            console.log("new User created in database");
                            //UPDATE USER LIST IN FIRM COLLECTION
                            firmRef
                              .update({
                                userlist: firebase.firestore.FieldValue.arrayUnion(
                                  newUser.email
                                )
                              })
                              .then(() => {
                                //SET USER
                                // let role = "admin";
                                commit("setUser", newUser);
                                // commit("setRole", role);
                                ///////////////EXPERIMENTAL///////////////////////////////

                                //GRAB MATTERS
                                let matterRef = firebase
                                  .firestore()
                                  .collection("matters")
                                  .where(
                                    "sharedWith",
                                    "array-contains",
                                    newUser.email
                                  );
                                matterRef
                                  .get()
                                  .then(matters => {
                                    let matterList = [];
                                    matters.forEach(matter => {
                                      matterList.push(matter);
                                    });
                                    //SET MATTERS
                                    commit("setMatters", matterList);
                                    commit("setLoading", false);
                                  })
                                  .then(() => {
                                    firebase.auth().signOut();
                                    firebase
                                      .auth()
                                      .signInWithEmailAndPassword(
                                        payload.email,
                                        payload.password
                                      )
                                      .then(resp => {
                                        //GET THE USER FROM DATABASE
                                        resp.user
                                          .getIdTokenResult()
                                          .then(idTokenResult => {
                                            // let role = idTokenResult.claims.admin;
                                            if (idTokenResult.claims.admin) {
                                              let role = "admin";
                                              commit("setRole", role);
                                              firebase
                                                .firestore()
                                                .collection("users")
                                                .doc(resp.user.email)
                                                .get()
                                                .then(user => {
                                                  user = user.data();
                                                  //SET USER
                                                  commit("setUser", user);
                                                  // return newUser;
                                                })
                                                .catch(e => {
                                                  console.log(e);
                                                });
                                            }
                                            if (idTokenResult.claims.client) {
                                              let role = "client";
                                              commit("setRole", role);
                                              firebase
                                                .firestore()
                                                // .collection("firms")
                                                // .doc(payload.firm)
                                                .collection("matters")
                                                .doc(payload.matter)
                                                .collection("clients")
                                                .doc(payload.client)
                                                .get()
                                                .then(user => {
                                                  user = user.data();
                                                  //SET USER
                                                  commit("setUser", user);
                                                  // return newUser;
                                                })
                                                .catch(e => {
                                                  console.log(e);
                                                  commit(
                                                    "setAppMessage",
                                                    e.message
                                                  );
                                                });
                                            }
                                          })
                                          .catch(e => {
                                            console.log(e);
                                            commit("setAppMessage", e.message);
                                          });
                                      })
                                      .catch(e => {
                                        console.log(e);
                                        commit("setAppMessage", e.message);
                                      });
                                    console.log(
                                      "new User email added to firm in database"
                                    );
                                  })

                                  .catch(err => {
                                    commit("setError", err);
                                    commit("setLoading", false);
                                    commit("setAppMessage", err.message);
                                  });
                              })
                              .catch(err => {
                                commit("setError", err);
                                commit("setLoading", false);
                                commit("setAppMessage", err.message);
                              });
                          })
                          .catch(err => {
                            commit("setError", err);
                            commit("setLoading", false);
                            commit("setAppMessage", err.message);
                          });
                      })
                      .catch(err => {
                        commit("setError", err);
                        commit("setLoading", false);
                        commit("setAppMessage", err.message);
                      });
                  }
                })
                .catch(err => {
                  commit("setError", err);
                  commit("setLoading", false);
                  commit("setAppMessage", err.message);
                });
            })
            .catch(err => {
              commit("setError", err);
              commit("setLoading", false);
              commit("setAppMessage", err.message);
            });
        }
      });
    }
  },
  getters: {
    // clientFormList(state) {
    //   return state.clientFormList;
    // },
    contentsList(state) {
      return state.contentsList;
    },
    propertySlug(state) {
      return state.propertySlug;
    },
    appMessage(state) {
      return state.appMessage;
    },
    user(state) {
      return state.user;
    },
    role(state) {
      return state.role;
    },
    firm(state) {
      return state.firm;
    },
    matters(state) {
      return state.matters;
    },
    getMatter(state) {
      return matterId =>
        state.matters.find(matter => matter.matterSlug === matterId);
    },
    initialDocs(state) {
      console.log("getting initial docs", state);
      return state.initialDocs;
    },
    plaintiffs(state) {
      console.log("getting plaintiffs docs", state.plaintiffs);
      return state.plaintiffs;
    },
    party(state) {
      return state.viewingParty;
    },
    plaintiff(state) {
      return state.viewingPlaintiff;
    },
    defendant(state) {
      return state.viewingDefendant;
    },
    selectedParties(state) {
      return state.selectedParties;
    },
    responses(state) {
      return state.viewingResponse;
    }
  },
  modules: {}
});
